import * as React from "react";
import { Box, Checkbox } from "@mui/material";
import { MinusSquare, Stop, TickSquare } from "iconsax-react";

// Inbox multi-select checkbox (row checkboxes in MessageCard.jsx + select-all in
// InboxBulkActionBar.jsx) drawn with Iconsax, the app's icon set: empty rounded square
// (Stop, Linear) / ticked (TickSquare, Bold) / partial (MinusSquare, Bold). Iconsax icons
// ignore MUI's sx, so each sits in a sized Box with size="100%" (see LeftNav.jsx pattern).

const iconBox = (size, color, Icon, variant) => (
  <Box sx={{ width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center", color }}>
    <Icon size="100%" color="currentColor" variant={variant} />
  </Box>
);

const BulkCheckbox = React.forwardRef(({ size = 22, sx, ...props }, ref) => (
  <Checkbox
    ref={ref}
    disableRipple
    icon={iconBox(size, "text.secondary", Stop, "Linear")}
    checkedIcon={iconBox(size, "primary.main", TickSquare, "Bold")}
    indeterminateIcon={iconBox(size, "primary.main", MinusSquare, "Bold")}
    sx={{ p: 0.25, "&:hover": { backgroundColor: "transparent" }, ...sx }}
    {...props}
  />
));

export default BulkCheckbox;
